import { useTranslation } from 'react-i18next';
import { Player } from '../../types/players';
import MyDrawer from '../ui/Drawer';
import { useMemo } from 'react';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';

interface Props {
  open: boolean;
  close: () => void;
  player: Player | null;
}

const renderPlayerDetail = (label: string, value?: string) => (
  <p>
    {label}: <span className="text-textGray">{value || ''}</span>
  </p>
);

const PlayerDetailsModal = ({ close, open, player }: Props) => {
  const { t, i18n } = useTranslation();

  const playerPosition = useMemo(
    () =>
      i18n.language === 'en'
        ? player?.position?.name
        : player?.position?.nameBg,
    [i18n.language, player?.position?.name, player?.position?.nameBg]
  );

  if (!player) {
    return <></>;
  }

  return (
    <MyDrawer isOpen={open} onClose={close}>
      <div
        className="items-center p-4 text-white h-screen w-full"
        style={{ zIndex: 1010 }}
      >
        <div className="flex w-full justify-end">
          <button onClick={close} className="text-white">
            X
          </button>
        </div>
        <div className="bg-additionalBlack rounded-lg mt-16">
          <div>
            {player.imageUrl ? (
              <img
                src={player.imageUrl}
                alt="Player"
                className="object-cover w-full h-[240px] rounded-lg"
              />
            ) : (
              <div className="w-full h-[240px] rounded-lg"></div>
            )}
          </div>
          <div className="flex flex-col p-3 gap-3">
            <span>
              <h2 className="font-inter text-2xl not-italic font-bold leading-7">
                {player.name}
                {player.age && `, ${player.age}`}
              </h2>
              {/* <p className="text-mainBlue font-semibold">
                {getPlayerRoleDisplayText(player, team)}
              </p> */}
            </span>
            <span>
              {player.nickname &&
                renderPlayerDetail(
                  t(COMMON_TRANSLATE_KEYS.NICKNAME),
                  player.nickname
                )}
              {player.city &&
                renderPlayerDetail(t(COMMON_TRANSLATE_KEYS.CITY), player.city)}
              {player.phone &&
                renderPlayerDetail(
                  t(COMMON_TRANSLATE_KEYS.PHONE),
                  player.phone
                )}
              {player.email &&
                renderPlayerDetail(
                  t(COMMON_TRANSLATE_KEYS.EMAIL),
                  player.email
                )}
              {player.position &&
                renderPlayerDetail(
                  t(COMMON_TRANSLATE_KEYS.POSITION),
                  playerPosition
                )}
            </span>
            {player.bio && <p className="text-textGray">{player.bio}</p>}
          </div>
        </div>
      </div>
    </MyDrawer>
  );
};

export default PlayerDetailsModal;
